export enum TicketDataLayout {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}
